const makeInitialState = () => {
  return {
    selectedEquipments: []
  };
};

export default makeInitialState;
